import {
  DELETE_AD_IMAGE,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_AVATAR,
} from "@/components/customer/admin/ducks/Actions"
import {
  apiDeleteAdImage,
  apiUpdateCustomer,
  apiUpdateCustomerAvatar,
} from "@/components/customer/admin/ducks/AJAX"
import { setCustomer } from "@/components/customer/ducks/Actions"

export default (store) => (next) => (action) => {
  const { dispatch } = store

  const updateCustomerSuccess = (cb, params) => (resp) => {
    if (
      params.primaryColor ||
      params.secondaryColor ||
      params.customSidebarLinkLocation ||
      params.img
    ) {
      const currentCust = store.getState().customer.user.customer

      if (
        currentCust.primaryColor !== params.primaryColor ||
        currentCust.secondaryColor !== params.secondaryColor ||
        currentCust.img !== params.img ||
        currentCust.name !== params.name ||
        params.customSidebarLinkLocation !== currentCust.customSidebarLinkLocation ||
        params.customSidebarLinkDisplayText !== currentCust.customSidebarLinkDisplayText
      ) {
        window.location.reload()
      }
    }
    if (resp.customer) {
      dispatch(setCustomer(resp.customer))
    }

    if (resp.adDeleted) {
      window.location.reload()
    }

    if (cb) {
      cb(resp)
    }
  }

  switch (action.type) {
    case UPDATE_CUSTOMER:
      // Might need to dispatch a "setCustomer" on success
      apiUpdateCustomer(
        action.customerId,
        action.params,
        updateCustomerSuccess(action.success, action.params),
        action.error,
      )
      return next(action)

    case UPDATE_CUSTOMER_AVATAR:
      apiUpdateCustomerAvatar(
        action.params,
        updateCustomerSuccess(action.success, action.params),
        action.error,
      )
      return next(action)

    case DELETE_AD_IMAGE:
      apiDeleteAdImage(
        action.params,
        updateCustomerSuccess(action.success, action.params),
        action.error,
      )
      return next(action)

    default:
      return next(action)
  }
}
